export default __webpack_public_path__ + "cyberwasteland.mp3";